<template>
	<article class="review">
		<PageHeader />
		<form @submit.prevent="paging(0)">
			<ManagingSection :column-count="2">
				<ManagingBox title="작성자">
					<SelectInput
						ref="writer"
						:select-list="writerTypeList"
						:default-select-value="writerType"
						@change="writerTypeChange"
					/>
				</ManagingBox>
				<ManagingBox title="성별">
					<RadioList
						v-model="gender"
						:radio-list="getListAddNull('gender')"
						value-name="name"
					/>
				</ManagingBox>
				<ManagingBox title="나이" :horizontal-mode="true">
					<Selector
						v-model="minAge"
						:option-list="minAgeList"
						value-key="id"
						class="review__birth-year"
					/>
					~
					<Selector
						v-model="maxAge"
						:option-list="maxAgeList"
						value-key="id"
						class="review__birth-year"
					/>
				</ManagingBox>
				<ManagingBox title="내용">
					<input v-model="reviewText" type="text" />
				</ManagingBox>
				<ManagingBox title="글자수">
					<PeriodBox
						mode="number"
						:from-value="minWordCount"
						:to-value="maxWordCount"
						:input-width="100"
						@change="wordCountChange"
					/>
				</ManagingBox>
				<ManagingBox title="IP 주소">
					<input v-model="ipAddress" type="text" />
				</ManagingBox>
				<ManagingBox title="브랜드">
					<SearchBrand ref="idBrand" @change="idBrandChange" />
				</ManagingBox>
				<ManagingBox title="회원 등급">
					<RadioList v-model="grade" :radioList="gradeList" />
				</ManagingBox>
				<ManagingBox title="제품">
					<SelectInput
						ref="product"
						:select-list="productTypeList"
						:default-select-value="productType"
						@change="productTypeChange"
					/>
				</ManagingBox>
				<ManagingBox title="리뷰 작성일">
					<DateRange v-model="datePeriod" type="date" />
				</ManagingBox>
				<ManagingBox title="카테고리">
					<CategorySelector
						ref="idCategory"
						@change="categoryChange"
					/>
				</ManagingBox>
				<ManagingBox title="리뷰 유형">
					<RadioList
						v-model="reviewType"
						:radio-list="reviewTypeList"
					/>
				</ManagingBox>
				<ManagingBox title="블라인드 상태">
					<RadioList
						v-model="state"
						:radio-list="stateList"
						value-name="name"
					/>
				</ManagingBox>
				<ManagingBox title="한줄평">
					<input v-model="reviewTitle" type="text" />
				</ManagingBox>
				<ManagingBox title="리뷰 감정">
					<RadioList
						v-model="sentiment"
						:radio-list="sentimentList"
					/>
				</ManagingBox>
			</ManagingSection>
			<div class="btn-wrap-main">
				<button
					type="submit"
					class="btn-main blue"
					v-text="'검색하기'"
				/>
				<button
					type="button"
					class="btn-main orange"
					v-text="'초기화'"
					@click="init"
				/>
				<button
					type="button"
					class="btn-main"
					v-text="'CSV 저장하기'"
					@click="openCsvModal"
				/>
			</div>
		</form>
		<ManagingSection :is-table="true">
			<template slot="infoSection">
				<p class="section__info__left">
					등록: {{ count.totalCount | currency }}건({{
						count.registerCount | currency
					}}명) / 정상: {{ count.normalCount | currency }}건 /
					블라인드: {{ count.blindCount | currency }}건 / 비전시:
					{{ count.unDisplayCount | currency }}건 / 검수중:
					{{ count.inspectionCount | currency }}건
				</p>
				<div class="section__info__right">
                    <button
						class="btn orange section__info__items"
						@click="batchReview"
					>
						리뷰 일괄 이동
					</button>

					<button
						class="btn orange section__info__items"
						@click="batchBlind"
					>
						블라인드 일괄처리
					</button>
					<Selector
						v-model="sort"
						:option-list="sortList"
						:is-v3="true"
						class="section__info__items"
						@input="paging(0)"
					/>
					<Selector
						v-model="limit"
						:option-list="getLimitList()"
						value-key="id"
						:is-v3="true"
						class="section__info__items"
						@input="paging(0)"
					/>
				</div>
			</template>
			<table class="table-main list">
				<thead>
					<tr>
						<th class="list__checkbox-item">
							<input
								v-model="allCheckModel"
								:value="allCheck"
								type="checkbox"
							/>
						</th>
						<th class="list__writer-item">작성자</th>
						<th class="list__grade-item" v-text="'회원등급'" />
						<th class="list__product-item">제품명</th>
						<th class="list__count-item">정상리뷰수</th>
						<th class="list__rating-item">
							<sort-button
								v-model="sort"
								:desc-id="7"
								:asc-id="8"
								title="평점"
								class="list__sort-button"
								@input="paging(0)"
							/>
						</th>
						<th class="list__like-item">
							<SortButton
								v-model="sort"
								:desc-id="9"
								:asc-id="10"
								title="좋아요"
								class="list__sort-button"
								@input="paging(0)"
							/>
						</th>
						<th>내용</th>
						<th class="list__ip-item">ip주소</th>
						<th class="list__date-item">작성시간</th>
						<th class="list__date-item">수정시간</th>
						<th class="list__state-item">
							<SortButton
								v-model="sort"
								:desc-id="3"
								:asc-id="4"
								title="전시상태"
								class="list__sort-button"
								@input="paging(0)"
							/>
						</th>
						<th class="list__state-item">리뷰상태</th>
						<th class="list__evaluation-item">리뷰유형</th>
						<th class="list__review-length-item">글자수</th>
					</tr>
				</thead>
				<tbody v-if="pending">
					<tr>
						<td colspan="15">불러오는중입니다.</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr v-for="item in list" :key="item.idReviewComment">
						<td class="list__checkbox-item">
							<input
								v-model="itemCheckModel"
								:value="item.idReviewComment"
								type="checkbox"
							/>
						</td>
						<td class="list__writer-item">
							<router-link
								:to="`/register/register-info/${item.writer.idRegister}`"
								class="link"
								>{{ item.writer.nickName }}</router-link
							>
						</td>
						<td class="list__grade-item" v-text="item.grade" />
						<td class="list__product-item">
							<a
								:href="`${adminDomain}/brand/${item.brand.idBrand}`"
								class="link list__product-item__brand"
								>[{{ item.brand.brandTitle }}]</a
							>
							<router-link
								:to="`/product/product-inquiry/${item.product.idProduct}`"
								class="link"
								>{{ item.product.productTitle }}</router-link
							>
						</td>
						<td class="list__count-item">
							{{ item.writer.reviewCount }}
						</td>
						<td class="list__rating-item">{{ item.rating }}</td>
						<td class="list__like-item">{{ item.likeCount }}</td>
						<td class="list__content-item">
							<router-link
								:to="`/review/${item.idReviewComment}`"
								class="link list__content-item__link"
							>
								<b v-if="item.title"
									>"{{ item.title }}"<br /><br
								/></b>
								<pre
									class="list__content-item-pre"
									v-html="item.reviewText"
								/>
							</router-link>
						</td>
						<td class="list__ip-item">{{ item.ipAddress }}</td>
						<td class="list__date-item">
							<p v-html="item.createDate" />
						</td>
						<td class="list__date-item">
							<p
								v-html="
									item.createDate === item.modifiedDate
										? '-'
										: item.modifiedDate
								"
							/>
						</td>
						<td class="list__state-item">{{ item.isDisplay }}</td>
						<td class="list__state-item">{{ item.state }}</td>
						<td class="list__evaluation-item">
							<RadioList
								v-model="item.reviewType"
								:radio-list="reviewTypeName"
								:vertical-ui="true"
								:key="`radio-${item.idReviewComment}-${item.reviewType}`"
								@inputWithOptional="
									evaluationChange(
										item.idReviewComment,
										$event.id,
										$event.lastId
									)
								"
							/>
						</td>
						<td class="list__review-length-item">
							{{ item.reviewText.length | currency }}
						</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				:totalItem="totalItem"
				:offset="offset"
				:limit="limit"
				slot="pagination"
				@to="paging($event.offset)"
			/>
		</ManagingSection>
	</article>
</template>
<script>
	import moment from 'moment';
	import { mapState, mapGetters } from 'vuex';
	import Util from '@/util';
	import PageHeader from '@/components/PageHeader';
	import ManagingSection from '@/components/layout/ManagingSection';
	import ManagingBox from '@/components/layout/ManagingBox';
	import SelectInput from '@/components/SelectInput';
	import RadioList from '@/components/RadioList';
	import Selector from '@/components/Selector';
	import PeriodBox from '@/components/PeriodBox';
	import SearchBrand from '@/components/SearchBrand';
	import DateRange from '@/components/DateRange';
	import CategorySelector from '@/components/product/CategorySelector';
	import SortButton from '@/components/SortButton';
	import PaginationBox from '@/components/PaginationBox';

	export default {
		name: 'ReviewList',
		components: {
			PageHeader,
			ManagingSection,
			ManagingBox,
			SelectInput,
			RadioList,
			Selector,
			PeriodBox,
			SearchBrand,
			DateRange,
			CategorySelector,
			SortButton,
			PaginationBox,
		},
		data() {
			return {
				pending: true,
				paramsKeys: [
					'nickname',
					'idRegister',
					'gender',
					'minAge',
					'maxAge',
					'reviewText',
					'minWordCount',
					'maxWordCount',
					'ipAddress',
					'idBrand',
					'productTitle',
					'idProduct',
					'datePeriod',
					'idFirstCategory',
					'idSecondCategory',
					'idThirdCategory',
					'reviewType',
					'state',
					'offset',
					'limit',
					'sort',
					'reviewTitle',
					'sentiment',
					'grade',
				],
				writerTypeList: [
					{ value: 'nickname', name: '닉네임' },
					{ value: 'idRegister', name: '회원번호' },
				],
				writerType: 'nickname',
				nickname: '',
				idRegister: '',
				gender: null,
				minAge: null,
				maxAge: null,
				reviewText: '',
				minWordCount: '',
				maxWordCount: '',
				ipAddress: '',
				idBrand: null,
				productTypeList: [
					{ value: 'productTitle', name: '제품명' },
					{ value: 'idProduct', name: '제품번호' },
				],
				productType: 'productTitle',
				productTitle: '',
				idProduct: '',
				datePeriod: { from: '', to: '' },
				idFirstCategory: null,
				idSecondCategory: null,
				idThirdCategory: null,
				reviewTypeList: [
					{ id: false, value: '모든 리뷰' },
					{ id: 'evaluation', value: '평가단 리뷰' },
					{ id: 'normal', value: '일반 리뷰' },
					{ id: 'pickple', value: '픽플 리뷰' },
				],
				reviewTypeName: [
					{ id: 'evaluation', value: '평가단' },
					{ id: 'normal', value: '일반' },
					{ id: 'pickple', value: '픽플' },
				],
				reviewType: false,
				state: null,
				sortList: [
					{ value: 1, name: '최신등록순' },
					{ value: 2, name: '이전등록순' },
					{ value: 3, name: '전시순' },
					{ value: 4, name: '비전시순' },
					{ value: 7, name: '평점높은순' },
					{ value: 8, name: '평점낮은순' },
					{ value: 9, name: '좋아요많은순' },
					{ value: 10, name: '좋아요적은순' },
				],
				sort: 1,
				totalItem: 0,
				offset: 0,
				limit: 10,
				list: [],
				count: {
					totalCount: 0,
					registerCount: 0,
					normalCount: 0,
					blindCount: 0,
					unDisplayCount: 0,
					inspectionCount: 0,
				},
				allCheck: false,
				itemCheck: [],
				reviewTitle: '',
				sentiment: null,
				sentimentList: [
					{ id: null, value: '전체' },
					{ id: 'POSITIVE', value: '긍정' },
					{ id: 'NEGATIVE', value: '부정' },
					{ id: 'NEUTRAL', value: '중립' },
					{ id: 'MIXED', value: '복합' },
				],
				grade: null,
			};
		},
		computed: {
			...mapState({
				adminDomain: state => state.env.adminDomain,
			}),
			...mapGetters({
				getListAddNull: 'getListAddNull',
				getLimitList: 'getLimitList',
				getItemById: 'getItemById',
			}),
			minAgeList() {
				return this.getListAddNull(
					'birthYear',
					null,
					'--- 시작나이 ---'
				);
			},
			maxAgeList() {
				return this.getListAddNull('birthYear', null, '--- 끝나이 ---');
			},
			stateList() {
				return this.getListAddNull('reviewCommentState');
			},
			allCheckModel: {
				get() {
					return this.allCheck;
				},
				set(allCheck) {
					this.allCheck = allCheck;
					this.itemCheck = allCheck
						? this.list.map(item => item.idReviewComment)
						: [];
				},
			},
			itemCheckModel: {
				get() {
					return this.itemCheck;
				},
				set(checkList) {
					this.itemCheck = checkList;
					this.allCheck = checkList.length === this.list.length;
				},
			},
			gradeList() {
				return this.getListAddNull('grade').map(({ id, name }) => ({
					id,
					value: name,
				}));
			},
		},
		watch: {
			'$route.query'() {
				this.getList();
				document.getElementById('admin2').scrollTop = 0;
			},
		},
		created() {
			this.getList();
		},
		mounted() {
			this.setFilter();
		},
		methods: {
			writerTypeChange({ select, input }) {
				this.writerType = select;
				this.writerTypeList.forEach(({ value }) => {
					this[value] = value === select ? input : '';
				});
			},
			wordCountChange({ from, to }) {
				this.minWordCount = from;
				this.maxWordCount = to;
			},
			idBrandChange({ idBrand }) {
				this.idBrand = idBrand;
			},
			productTypeChange({ select, input }) {
				this.productType = select;
				this.productTypeList.forEach(({ value }) => {
					this[value] = value === select ? input : '';
				});
			},
			categoryChange({ category1, category2, category3 }) {
				this.idFirstCategory = category1;
				this.idSecondCategory = category2;
				this.idThirdCategory = category3;
			},
			getParams() {
				const query = this.$route.query;

				return this.paramsKeys.reduce((acc, key) => {
					if (key === 'offset') {
						acc[key] = query[key] || 0;
					} else if (key === 'limit') {
						acc[key] = query[key] || 10;
					} else if (key === 'datePeriod' && query[key]) {
						const [from, to] = query[key].split(',');
						if (from) {
							acc.minDate = from;
						}
						if (to) {
							acc.maxDate = to;
						}
					} else if (key === 'reviewType' && query[key]) {
						acc[key] = query[key];
					} else if (query[key]) {
						acc[key] = query[key];
					}
					return acc;
				}, {});
			},
			async getList() {
				try {
					this.pending = true;
					const params = this.getParams();
					const { data } = await this.$axiosAdmin2.get(
						'/v3/api/review/list',
						{ params }
					);
					this.count = data.reviewCount;
					this.totalItem = data.reviewList.contentTotal;
					this.list = data.reviewList.data.map(item => {
						return {
							...item,
							createDate: moment(
								item.createDate,
								'YYYYMMDDHHmmss'
							).format('YYYY-MM-DD<br>HH:mm:ss'),
							modifiedDate: moment(
								item.modifiedDate,
								'YYYYMMDDHHmmss'
							).format('YYYY-MM-DD<br>HH:mm:ss'),
							isDisplay: item.isDisplay ? '전시' : '비전시',
							state: this.getItemById(
								'reviewCommentState',
								item.state
							).name,
							grade: this.$store.getters.getItemById(
								'grade',
								item.writer.grade
							)?.name,
							reviewType: item.isEvaluation
								? 'evaluation'
								: item.isPickple
									? 'pickple'
									: 'normal',
						};
					});
					console.log(this.list);
				} catch (err) {
					console.error(err);
				} finally {
					this.pending = false;
				}
			},
			async evaluationChange(idReviewComment, id, lastId) {
				console.log('idReviewComment', idReviewComment);
				console.log('id', id);
				if (!confirm('리뷰 유형을 변경하시겠습니까?')) {
					await this.$nextTick();
					this.list.find(
						item => item.idReviewComment === idReviewComment
					).reviewType = lastId;
					return;
				}

				const params = {
					idReviewComments: [idReviewComment],
					type: id === 'normal' ? lastId : id,
					value: id === 'normal' ? false : true,
				};

				await this.$axiosAdmin2.put('/v3/api/review/type', params);
			},
			search() {
				const query = this.paramsKeys.reduce((acc, key) => {
					const value = this[key];
					switch (key) {
						case 'sort':
							acc[key] = value || 1;
							break;
						case 'offset':
							acc[key] = value || 0;
							break;
						case 'datePeriod':
							if (value.from || value.to) {
								acc[key] = `${value.from},${value.to}`;
							}
							break;
						case 'isEvaluation':
							if (value && value !== false) {
								acc[key] = value;
							}
							break;
						default:
							acc[key] = value;
							break;
					}

					return acc;
				}, {});
				this.$router.replace({ query }).catch(() => {
					window.location.reload();
				});
			},
			paging(offset) {
				this.offset = offset;
				this.search();
			},
			setSelectInput(query, keys) {
				return keys.forEach(key => {
					const target = this[`${key}TypeList`].find(
						item => query[item.value]
					);
					this.$refs[key].selectModel = this[`${key}Type`] = target
						? target.value
						: this[`${key}TypeList`][0].value;
					this.$refs[key].inputModel = target
						? query[target.value]
						: '';
				});
			},
			setFilter() {
				const query = this.$route.query;
				this.setSelectInput(query, ['writer', 'product']);
				if (query.idBrand) {
					this.$refs.idBrand.setBrandOnlyId(Number(query.idBrand));
				} else {
					this.$refs.idBrand.init();
				}
				if (query.idFirstCategory) {
					this.$refs.idCategory.setCategory({
						category1: Number(query.idFirstCategory) || null,
						category2: Number(query.idSecondCategory) || null,
						category3: Number(query.idThirdCategory) || null,
					});
				} else {
					this.$refs.idCategory.categoryChange({
						level: 1,
						idParentCategory: null,
						category1: null,
						category2: null,
						category3: null,
					});
				}
				this.reviewType = query.reviewType || false;
				this.sort = Number(query.sort) || 1;
				this.offset = Number(query.offset) || 0;
				this.limit = Number(query.limit) || 10;
				this.paramsKeys.forEach(key => {
					const value = query[key];
					switch (key) {
						case 'reviewText':
						case 'ipAddress':
						case 'state':
						case 'nickname':
						case 'idRegister':
						case 'productTitle':
						case 'idProduct':
						case 'reviewTitle':
							this[key] = value || null;
							break;
						case 'gender':
						case 'minWordCount':
						case 'maxWordCount':
						case 'minAge':
						case 'maxAge':
						case 'idBrand':
						case 'grade':
							this[key] = Number(value) || null;
							break;
						case 'datePeriod':
							this[key] = {
								from: value ? value.split(',')[0] : '',
								to: value ? value.split(',')[1] : '',
							};
							break;
					}
				});
			},
			init() {
				this.$router.replace({ query: {} }).catch(() => {
					window.location.reload();
				});
				this.setFilter();
			},
			openCsvModal() {
				const clickCb = async (params, period) => {
					params.isCsvDownload = true;
					const { data, config } = await this.$axiosAdmin2.get(
						'/v3/api/review/list',
						{ params }
					);
					const rows = data.reviewList.data.map(item => [
						item.idReviewComment,
						item.writer.idRegister,
						item.writer.nickName,
						this.getItemById('grade', item.writer.grade)?.name,
						item.writer.age,
						this.getItemById('skinType', item.writer.skinType)
							?.name,
						item.product.idProduct,
						item.brand.brandTitle,
						item.product.productTitle,
						item.product.categoryGroup.firstCategoryText,
						item.product.categoryGroup.secondCategoryText,
						item.product.categoryGroup.thirdCategoryText,
						item.writer.reviewCount,
						item.rating,
						item.likeCount,
						item.reportCount,
						item.title,
						item.reviewText?.normalize(), // 유니코드 정규화 방식을 NFC 형태로 변경
						item.ipAddress,
						moment(item.createDate, 'YYYYMMDDHHmmss').format(
							'YYYY년 MM월 DD일 HH시 mm분'
						),
						item.createDate === item.modifiedDate
							? '-'
							: moment(
									item.modifiedDate,
									'YYYYMMDDHHmmss'
								).format('YYYY년 MM월 DD일 HH시 mm분'),
						this.getItemById('reviewCommentState', item.state)
							?.name,
						item.isEvaluation ? 'Y' : 'N',
						item.isPickple ? 'Y' : 'N',
						item.isDisplay ? 'Y' : 'N',
						Util.currency(item.reviewText.length.toString()),
					]);
					const title = `리뷰목록관리(${period.replace(/(\s*)/g, '')})_${Date.now()}`;
					Util.getCsv(
						[rows],
						[title],
						[
							[
								'리뷰ID',
								'회원ID',
								'작성자',
								'회원등급',
								'나이',
								'피부타입',
								'제품번호',
								'브랜드',
								'제품명',
								'1차 카테고리',
								'2차 카테고리',
								'3차 카테고리',
								'리뷰 수',
								'평점',
								'좋아요',
								'신고 수',
								'한줄평',
								'내용',
								'IP주소',
								'작성시간',
								'수정시간',
								'리뷰상태',
								'평가단 여부',
								'픽플 여부',
								'노출상태',
								'글자수',
							],
						],
						`글로우픽_${title}`,
						config.url
					);
				};
				this.$store.commit('modal/toggleModal', {
					id: 'ExcelDownList',
					params: {
						total: this.totalItem,
						type: 'reviewList',
						params: this.getParams(),
						clickCb,
					},
				});
			},
			async batchBlindCb() {
				await this.getList();
				this.allCheckModel = false;
			},
			batchBlind() {
				if (!this.itemCheck.length) {
					alert('블라인드 처리할 리뷰를 선택해 주세요.');
					return;
				}
				this.$store.commit('modal/toggleModal', {
					id: 'BatchBlind',
					params: {
						idReviewComments: this.itemCheck,
						cb: this.batchBlindCb,
					},
				});
			},
			async batchReviewProductCb() {
				await this.getList();
				this.allCheckModel = false;
			},
			batchReview() {
				if (!this.itemCheck.length) {
					alert('일괄 처리할 리뷰를 선택해 주세요.');
					return;
				}
				this.$store.commit('modal/toggleModal', {
					id: 'BatchReviewProduct',
					params: {
						idReviewComments: this.itemCheck,
						cb: this.batchReviewProductCb,
					},
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	article {
		.review__birth-year {
			margin: 0 8px;

			&:first-child {
				margin-left: 0;
			}
		}

		.list__checkbox-item {
			width: 30px;
			padding: 0;
		}

		.list__writer-item {
			width: 90px;
			padding: 0;
		}

		.list__grade-item {
			width: 78px;
			padding: 0;
		}

		.list__product-item {
			width: 200px;
			padding: 0;
		}

		.list__count-item {
			width: 72px;
			padding: 0;
			white-space: nowrap;
		}

		.list__rating-item {
			width: 38px;
			padding: 0;
			white-space: nowrap;
		}

		.list__like-item {
			width: 48px;
			padding: 0;
			white-space: nowrap;
		}

		.list__content-item {
			text-align: left;
		}

		.list__ip-item {
			width: 90px;
			padding: 0;
			white-space: nowrap;
		}

		.list__date-item {
			width: 90px;
			padding: 0;
		}

		.list__state-item {
			width: 70px;
			padding: 0;
			white-space: nowrap;
		}

		.list__evaluation-item {
			width: 78px;
			padding: 0;
		}

		.list__pickple-item {
			width: 78px;
			padding: 0;
		}

		.list__review-length-item {
			width: 50px;
			padding: 0;
			white-space: nowrap;
		}

		.list__sort-button {
			display: flex;
			align-items: center;
			margin: 0 auto;
		}

		.list__product-item__brand {
			display: block;
			color: $green;
		}

		.list__content-item__link {
			word-break: break-all;
		}

		.list__content-item-pre {
			white-space: pre-line;
			background: transparent;
		}
	}
</style>
